import { z } from 'zod';
/**
 * Единый конверт ответа нашего API.
 * Форма выбрана намеренно похожей на ChatApp — их API отвечает
 * { success, data } / { success, error } — чтобы не переключаться между
 * двумя разными соглашениями при отладке интеграции.
 */
export const apiErrorSchema = z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
    /**
     * Идентификатор запроса. Подставляется сервером в каждый ответ об ошибке
     * и показывается в интерфейсе рядом с сообщением. Смысл простой: человек,
     * столкнувшийся с ошибкой, называет одну строку, и по ней в логах находится
     * ровно его случай — без выяснений «а когда примерно это было».
     */
    requestId: z.string().optional(),
});
export function okResult(data) {
    return { success: true, data };
}
export function errorResult(error) {
    return { success: false, error };
}
/** Оборачивает схему полезной нагрузки в конверт — для разбора ответа на фронтенде. */
export function apiResultSchema(payload) {
    return z.discriminatedUnion('success', [
        z.object({ success: z.literal(true), data: payload }),
        z.object({ success: z.literal(false), error: apiErrorSchema }),
    ]);
}
//# sourceMappingURL=api-result.js.map